module.exports = __webpack_public_path__ + "img/pw.f34a17aa.svg";